import React from "react";

import { AdvertImage, Usage } from "@at/design-system-patterns";

interface AdvertImageProps {
  src: string;
  alt?: string;
}

export const GalleryGridModalMainImage = ({ src, alt }: AdvertImageProps) => {
  return (
    <AdvertImage
      {...{
        alt,
        src,
        usage: Usage.Main,
        pageBreakpoints: {
          "800": 600,
          "600": 300,
        },
      }}
    />
  );
};

export const GalleryGridModalThumbnailImage = ({
  src,
  alt,
}: AdvertImageProps) => {
  return (
    <AdvertImage
      {...{
        alt,
        src,
        usage: Usage.Result,
      }}
    />
  );
};
